module.exports = __webpack_public_path__ + "static/media/aboutus_m@2x.fb706778.jpg";